import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    value: { default: '' },
    placeholder: { default: 'Search...' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({ (e: 'input', value: string): void }), expose: any, slots: any, attrs: any }) {





function onInput(event: Event) {
  emit('input', (event.target as HTMLInputElement).value);
}

return { __sfc: true,emit, onInput }
}

})